import { dataExclamationCircleSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconExclamationCircleSolid = /*#__PURE__*/createIcon(dataExclamationCircleSolid)
export default IconExclamationCircleSolid
